"use client";

import { useEffect, useSyncExternalStore } from "react";

import {
  boundUrlSource,
  boundUrlsVersion,
  claimViewerLoad,
  isViewerLoadAllowed,
  subscribeBoundUrls,
  type UrlSourceClass,
} from "../../shared/browser/boundUrlSet.ts";

const serverVersion = () => 0;

/** Re-renders whenever the bound URL set or a load decision changes. */
export function useBoundUrlsVersion(): number {
  return useSyncExternalStore(subscribeBoundUrls, boundUrlsVersion, serverVersion);
}

/** The source class `url` is bound with, or null while it is unbound. */
export function useBoundUrlSource(url: unknown): UrlSourceClass | null {
  useBoundUrlsVersion();
  return boundUrlSource(url);
}

/**
 * True once viewer window `viewerId` may show `url`: an allowed open left it
 * a ticket, or this turn's unused grant names it. Claims either as soon as
 * one exists, so a grant that arrives after the window mounts still opens it.
 * With `claim: false` (a page a website sent) it never claims: only the
 * viewer's own Load tap (loadViewerOnGesture) allows the page.
 */
export function useViewerLoad(viewerId: string, url: string | null, { claim = true }: { claim?: boolean } = {}): boolean {
  const version = useBoundUrlsVersion();
  const allowed = !!url && isViewerLoadAllowed(viewerId, url);
  useEffect(() => {
    if (claim && url && !allowed) claimViewerLoad(viewerId, url);
  }, [allowed, claim, url, version, viewerId]);
  return allowed;
}
